import React from 'react';
import { useSelector } from 'react-redux';
import { Button, Col, Input } from 'antd';
import i18n from 'i18next';
import { GlobalModalClose } from '../../layout/GlobalModal';
import { getAppGlobalState } from '../../../store/app-globals/selectors';

interface DeleteProps {
  onPressDelete?: (
    e?: React.MouseEvent<Element, MouseEvent> | undefined
  ) => void;
  handleFieldChange?: (e: any) => void;
}

export const DeleteModal: React.FC<DeleteProps> = ({ onPressDelete }) => {
  const { isLoading, message } = useSelector(getAppGlobalState);
  const handleCancelButton = () => GlobalModalClose();

  return (
    <div className="modal-content-wrapper">
      <div className="modal-content-description">
        <span>{i18n.t('DELETE_MESSAGE')}</span>
      </div>
      <div className="button-container">
        <Button
          block
          type="primary"
          shape="round"
          className="continue-button continue-button-primary"
          onClick={onPressDelete}
          loading={isLoading}
          disabled={isLoading}
        >
          <span className="continue-button-text">
            {isLoading ? message : i18n.t('DELETE')}
          </span>
        </Button>
        <Button
          block
          shape="round"
          className="cancel-button cancel-button-primary"
          onClick={handleCancelButton}
          disabled={isLoading}
        >
          <span className="continue-button-text">{i18n.t('Cancel')}</span>
        </Button>
      </div>
    </div>
  );
};

export const AdminDeleteModal: React.FC<DeleteProps> = ({
  onPressDelete,
  handleFieldChange,
}) => {
  const { isLoading, message } = useSelector(getAppGlobalState);
  const handleCancelButton = () => GlobalModalClose();

  return (
    <div className="modal-content-wrapper">
      <Col className="input-field-container">
        <Input.TextArea
          placeholder="Write a reason why deleting this offer"
          className="input-field"
          // value={reason}
          onChange={handleFieldChange}
        />
      </Col>
      <div className="button-container">
        <Button
          block
          type="primary"
          shape="round"
          className="continue-button continue-button-primary"
          onClick={onPressDelete}
          loading={isLoading}
          disabled={isLoading}
        >
          <span className="continue-button-text">
            {isLoading ? message : i18n.t('DELETE')}
          </span>
        </Button>
        <Button
          block
          shape="round"
          className="cancel-button cancel-button-primary"
          onClick={handleCancelButton}
          disabled={isLoading}
        >
          <span className="continue-button-text">{i18n.t('Cancel')}</span>
        </Button>
      </div>
    </div>
  );
};
